export default __webpack_public_path__ + "icon-ai0f8ff3.png";